export default "__VITE_ASSET__DxNIunUm__"